var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loaded)?_c('ejs-maps',{attrs:{"zoomSettings":_vm.zoomSettings},on:{"markerClick":function($event){return _vm.onLocationClicked($event)}}},[_c('e-layers',[_c('e-layer',{attrs:{"layerType":"OSM"}},[_c('e-markerSettings',[_vm._l((_vm.locations),function(loc){return [_c('e-markerSetting',{key:loc.id,attrs:{"visible":"true","dataSource":[
											{
												latitude: loc.gps.lat,
												longitude: loc.gps.lng,
												name: loc.name
											}
										],"shape":"InvertedTriangle","height":"25","width":"25"}})]})],2)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }